const footerstore={
    data:{
        Footer :[
            {title: 'About us',link : 'About us',Content : 'The Solsavi is managed by Auroville Consulting. Auroville Consulting is a unit of the Auroville Foundation and works to establish a prosperous eco-system that supports all life on this planet.'},
            {title: 'Contact Us',link : 'Contact Us' ,Content : 'Auroville Consulting A unit of the Auroville Foundation E: xxx@xxx Crown Road, Kalpana 4, Auroville, Tamil Nadu - 605101, India'},
            {title: 'Useful Links',link : 'Useful Links' ,Content : 'Auroville Consulting Auroville Green Practices Solasavi Carbon Converter Solse '},
            {title: 'Disclaimer',link : 'Disclaimer' ,Content : 'Terms and conditions'},
        ]
    }
}
export default footerstore